// event-bus.js
import Vue from 'vue';
export const EventBus = new Vue();

// 假设这是一个全局变量
export let globalVar = '';
 
export function setGlobalVar(value) {
  globalVar = value;
  EventBus.$emit('globalVarChanged', globalVar);
}


// WEBPACK FOOTER //
// ./src/utils/event-bus.js